module.exports = __webpack_public_path__ + "img/ic_company.95e0baa3.svg";